import React from "react";
import "./Myportfolio.css";
import ChartSection from "./chart-section/ChartSection";
import ExperienceSection from "./Experience-section/ExperienceSection";
import ProjectPrimarySkill from "./Primary-skill/ProjectPrimarySkill";
const ProjectTabPage = () => {
  return (
    <>
      <section className="my-portfolio">
        <div className="container">
          <ChartSection />
          <ExperienceSection />
          <ProjectPrimarySkill />
        </div>
      </section>
    </>
  );
};

export default ProjectTabPage;
